import { useTranslation } from 'react-i18next'

import { EntityProfileHeaderInfoItemBase } from '../../../Entity'
import { Switch } from '../../../Switch'
import { getNewsboardCommentsSwitchLabelKey } from '../../NewsboardPostForm'
import { NEWSBOARD_POST_PROFILE_HEADER_INFO_ITEM_TITLE_KEYS } from '../NewsboardPostProfileHeaderInfoItems.constants'

function NewsboardPostProfileHeaderInfoItemComments({
  canEdit,
  disabled,
  name,
  value,
  onChange,
}) {
  const { t } = useTranslation()

  return (
    <EntityProfileHeaderInfoItemBase
      canEdit={false}
      title={NEWSBOARD_POST_PROFILE_HEADER_INFO_ITEM_TITLE_KEYS[name]}
    >
      <Switch
        disabled={!canEdit || disabled}
        label={t(getNewsboardCommentsSwitchLabelKey(value))}
        value={value}
        onChange={onChange}
      />
    </EntityProfileHeaderInfoItemBase>
  )
}

export default NewsboardPostProfileHeaderInfoItemComments
